// utils/quillCustomBlots.js
import { Quill } from 'react-quill'; // Use Quill from react-quill to avoid dual instance issues

const BlockEmbed = Quill.import('blots/block/embed');
const ImageBlot = Quill.import('formats/image');

class DividerBlot extends BlockEmbed {
    static blotName = 'divider';
    static tagName = 'hr';
}
Quill.register(DividerBlot);

class PageBreakBlot extends BlockEmbed {
    static blotName = 'pageBreak';
    static tagName = 'div';
    static className = 'page-break';

    static create(value) {
        const node = super.create(value);
        node.setAttribute('class', this.className);
        return node;
    }
}
Quill.register(PageBreakBlot);

class CustomImageBlot extends ImageBlot {
    static create(value) {
        const node = super.create(value);
        node.setAttribute('src', value);

        // Inject style
        node.setAttribute(
            'style',
            'max-width: 250px; height: auto; '
        );

        return node;
    }
}

CustomImageBlot.blotName = 'image'; // Override default
CustomImageBlot.tagName = 'IMG';    // Same as native
Quill.register(CustomImageBlot, true); // Register + override default